import React from 'react';
import { Link, useTranslate } from 'react-admin';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import IconButton from '../../common/buttons/IconButton';

const CalendarButton = () => {
    const translate = useTranslate();

    return (
        <IconButton component={Link} to="/time_entries/calendar" icon={<CalendarMonthIcon />}>{translate('Calendar')}</IconButton>
    );
};

export default CalendarButton;